import { useEffect, useRef, useState } from 'react';

// The items selected by focusableItemsSelector need to have tabIndexes
// set to -1, except for the item matching the focusedIndex, which is set to 0.
export const useArrowKeyFocusing = ({ focusableItemsSelector }) => {
  const [focusedIndex, setFocusedIndex] = useState(0);

  // This ref will get attached to a parent of the focusable items, and only within
  // this ref will the items be searched for.
  const parentRef = useRef(null);

  const moveFocus = (event) => {
    const items = parentRef?.current.querySelectorAll(focusableItemsSelector);

    if (event.code === 'ArrowUp' || event.code === 'ArrowLeft') {
      const newIndex = focusedIndex - 1;
      if (newIndex < 0) {
        setFocusedIndex(items.length - 1);
      } else {
        setFocusedIndex(newIndex);
      }
    }

    if (event.code === 'ArrowDown' || event.code === 'ArrowRight') {
      const newIndex = focusedIndex + 1;
      if (newIndex === items.length) {
        setFocusedIndex(0);
      } else {
        setFocusedIndex(newIndex);
      }
    }
  };

  useEffect(() => {
    const items = parentRef?.current.querySelectorAll(focusableItemsSelector);
    items[focusedIndex]?.focus();
  }, [focusedIndex]);

  return { parentRef, moveFocus, focusedIndex };
};
